import React from 'react';
import { Badge } from '@cargomatic/ui';
import { humanize } from 'underscore.string';
export const CustomerTypeBadge = ({ customerType }) => {
    let color;
    if (!customerType) {
        return null;
    }
    if (customerType === 'shipper') {
        color = 'green';
    }
    else {
        color = 'blue';
    }
    return React.createElement(Badge, { color: color }, humanize(customerType));
};
